import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MasterFormFieldComponent } from "./master-form-field/master-form-field.component";
import { MasterSelectFieldComponent } from "./master-select-field/master-select-field.component";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MasterProcurementComponent } from "./master-procurement/master-procurement.component";
import { FooterComponent } from "../../core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatIconModule } from "@angular/material/icon";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
  declarations: [
    MasterFormFieldComponent, 
    MasterSelectFieldComponent,
    MasterProcurementComponent,FooterComponent
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    MatSnackBarModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxMatSelectSearchModule,
    MatPaginatorModule,
    MatIconModule,
    MatGridListModule,
    MatTooltipModule
  ],
  exports: [
    MasterFormFieldComponent,
    MasterSelectFieldComponent,
    MasterProcurementComponent,
    FooterComponent
  ]
})
export class SharedModule {}
